import React from 'react';
import { useLandingSettings } from '../useLandingSettings';
import { QUALIFY_FOOTNOTE, QUALIFY_INTRO, QUALIFY_ITEMS } from '../content';

const interFont = { fontFamily: 'Inter, sans-serif' };

const CheckIcon: React.FC = () => (
  <span
    className="flex size-6 shrink-0 items-center justify-center rounded-full text-white"
    style={{ backgroundColor: 'var(--color-primary, #143b6b)' }}
  >
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="m5 12 5 5L20 7" />
    </svg>
  </span>
);

export const WhoQualifies: React.FC = () => {
  const { qualify } = useLandingSettings();
  const hasQualifyImage = Boolean(qualify?.trim());

  return (
    <section className="px-4 md:px-8">
      <div
        className={`relative mx-auto flex sm:min-h-[520px] max-w-[1180px] items-start overflow-hidden rounded-[28px] bg-[#f5eee2] md:min-h-[660px] ${
          hasQualifyImage ? 'md:bg-transparent' : ''
        }`}
      >
        {hasQualifyImage && (
          <>
            <img
              src={qualify}
              alt=""
              className="absolute inset-0 hidden h-full w-full object-cover object-[78%_center] md:block"
            />
            <div className="absolute inset-0 hidden bg-gradient-to-r from-[#f5eee2] from-30% via-[#f5eee2]/80 to-transparent md:block" />
          </>
        )}

        <div className="relative z-10 max-w-[720px] px-8 py-10 md:px-14 md:py-14">
          <h2
            className="font-['Inter'] text-[40px] sm:text-[clamp(2.25rem,65px,78px)] font-light leading-[1.02] text-[#23262C] md:whitespace-nowrap"
            style={interFont}
          >
            Who Qualifies?
          </h2>
          <p
            className="mt-7 font-['Inter'] text-base sm:text-[clamp(1.125rem,1.8vw,21px)] font-normal leading-[1.4] text-[#55585f]"
            style={interFont}
          >
            {QUALIFY_INTRO}
          </p>
          <ul className="mt-8 space-y-5">
            {QUALIFY_ITEMS.map((item) => (
              <li key={item} className="flex items-center gap-4">
                <CheckIcon />
                <span
                  className="font-['Inter'] text-base sm:text-[clamp(1.125rem,1.8vw,21px)] font-normal leading-[1.4] text-[#55585f]"
                  style={interFont}
                >
                  {item}
                </span>
              </li>
            ))}
          </ul>
          <p
            className="mt-8 max-w-[640px] font-['Inter'] text-sm font-normal leading-[1.45] text-[#55585f] sm:text-base"
            style={interFont}
          >
            {QUALIFY_FOOTNOTE}
          </p>
        </div>
      </div>
    </section>
  );
};
